import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStorageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M2.703 13.536v-8.38L8.13 2.578l5.426 2.578v8.38"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.733 8.383h2.411v5.156H5.115V9.672h3.618"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M8.732 13.532V7.73a.67.67 0 0 0-.177-.455.58.58 0 0 0-.426-.19H6.923a.58.58 0 0 0-.426.19.67.67 0 0 0-.177.455v1.934"
    />
  </svg>
);
export default SvgStorageIcon;
